<template>
  <article class="col-md-18">
    <h1>Resellers</h1>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Name</th>
          <th scope="col">Jasper wireless code</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="reseller in resellers" :key="reseller.id">
          <td>{{ reseller.id }}</td>
          <td>{{ reseller.displayName }}</td>
          <td>{{ reseller.jasperWirelessCode }}</td>
          <td>
            <a
              href="#"
              @click.prevent="view(reseller)"
              class="btn btn-primary btn-sm"
              >View</a
            >
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4">
            <a
              href="#"
              @click.prevent="create()"
              class="btn btn-primary btn-sm"
            >
              New
            </a>
          </td>
        </tr>
      </tfoot>
    </table>
  </article>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Resellers',
  data() {
    return {
      loading: false,
      resellers: null,
    }
  },
  methods: {
    getResellers() {
      this.loading = true
      axios
        .get('/rest/reseller')
        .then(response => {
          this.resellers = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    view(reseller) {
      this.$router.push(`/secure/resellers/${reseller.id}`)
    },
    create() {
      this.$router.push('/secure/resellers/new')
    },
  },
  beforeMount() {
    this.getResellers()
  },
}
</script>

<style lang="scss"></style>
